import { Box, Stack, Paper } from '@mui/material';
import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import Grid from '@mui/material/Grid';
import StyledTableRow from '../shared/components/styledTableRow';
import StyledTableCell from '../shared/components/styledTableCell';
import { GetDayJSValueFromUTCDate } from '../utils/extensions/functionEx';
import { DATE_DISPLAY_FORMAT } from '../startups/apiConfig';

const NurseVacationReminder = (props) => {
    const { nurseVacations } = props;

    return (
        <Box sx={{ bgcolor: '#cfe8fc', padding: '8px, 0' }}>
            <Stack spacing={0}>
                <Grid container spacing={1}>
                    <Grid size={12}>
                        <TableContainer component={Paper} sx={{ maxHeight: '77vh' }}>
                            <Table stickyHeader sx={{ minWidth: 700 }}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell sx={{ width: '400px' }}>Nurse Name</StyledTableCell>
                                        <StyledTableCell sx={{ width: '350px' }}>Nurse Phone</StyledTableCell>
                                        <StyledTableCell sx={{ width: '150px' }}>Start Date</StyledTableCell>
                                        <StyledTableCell sx={{ width: '150px' }}>End Date</StyledTableCell>
                                        <StyledTableCell>Notes</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {nurseVacations.map((row) => (
                                        <StyledTableRow key={row.id.toString()}>
                                            <StyledTableCell>{row.nurse_name}</StyledTableCell>
                                            <StyledTableCell>{row.nurse_phone}</StyledTableCell>
                                            <StyledTableCell component="th" scope="row">
                                                {GetDayJSValueFromUTCDate(row.start_date).format(DATE_DISPLAY_FORMAT)}
                                            </StyledTableCell>
                                            <StyledTableCell>{GetDayJSValueFromUTCDate(row.end_date).format(DATE_DISPLAY_FORMAT)}</StyledTableCell>
                                            <StyledTableCell>{row.remarks}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Stack>
        </Box>
    );
}
export default NurseVacationReminder;